import { Layout } from "antd";
import styles from "./auth-layout.module.css";
const { Content } = Layout;

const AuthLayout = ({ config, children }) => {
  return (
    <Layout className={styles.page}>
      <Content className={styles.content}>
        <div className={styles.card}>
          <div className={styles.logoWrap}>
            {config?.logo_path && (
              <img src={config.logo_path} alt="" className={styles.logo} />
            )}
            <span
              className={
                !config?.is_red_logo
                  ? styles.logoName
                  : styles.logoNamePlaceholder
              }
            >
              {config?.system_name}
            </span>
          </div>
          {children}
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
